import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ProductVariantDeletePermanently as SchemaProductVariantDeletePermanently } from '../schemas/ProductVariantDeletePermanently';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const DeletePermanentlyProductVariantsContentType = 'application/json' as const;
export type DeletePermanentlyProductVariantsRequest = SchemaProductVariantDeletePermanently;
export type DeletePermanentlyProductVariantsResponses = LinkCommonErrorResponses & {};
export type DeletePermanentlyProductVariantsResponseSuccess = undefined;
export type DeletePermanentlyProductVariantsSearchParams = undefined;
export type DeletePermanentlyProductVariantsPathParameters = undefined;
export const DeletePermanentlyProductVariantsUrl = '/variants/archived/delete-permanently' as const;
export const DeletePermanentlyProductVariantsMethod = 'DELETE' as const;
export const getDeletePermanentlyProductVariantsUrl = (_params?: DeletePermanentlyProductVariantsPathParameters) =>
    DeletePermanentlyProductVariantsUrl;
